import React from 'react'
import "./ReplicateCard.css"
import tennisBall from "../../assets/images/icone_bola.svg"
import { Col, Row } from 'react-bootstrap';

class ReplicateCard extends React.Component {
    render() {
        let margin_value = this.props.lastItem ? 170 : 10;
        
        return (
            <Col xs={12}>
                <Col xs={12}  className="card-games p-2 mb-3" onClick={this.props.onClick}>
                    <Row>
                        {this.props.children && ( <Col  xs={{ span: 8, offset: 2 }} className={"label"}>
                            {this.props.children}
                        </Col>)}
                    </Row>

                    <Row className={"align-items-center"}>
                        <Col xs={2} sm={1}>
                            <img className="tennis-ball-logo tennis-ball-positioning" src={tennisBall} alt="tennis ball icon" />
                        </Col>
                        <Col xs={10} sm={11}>
                            <p className={"league-name-text"}>{this.props.leagueName}</p>
                            <p className="league-date-text card-league-date-text">{this.props.category} {this.props.teamPlayers}</p>
                        </Col>
                    </Row>
                </Col>
            </Col>
        )
    }
}

export default ReplicateCard